module.exports = __webpack_public_path__ + "img/cdt.54bbb7bf.png";